<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
<div class="min-h-screen bg-gray-50">
<div class="mx-auto ">
<!-- 顶部标题区 -->
<div class="mb-8 flex justify-between items-center">
<div>
<h1 class="text-3xl font-bold text-gray-900">笔记推流管理</h1>
<p class="mt-2 text-gray-600">选择笔记并设置目标城市进行内容推送</p>
</div>
<div class="flex gap-4">
<button class="!rounded-button flex items-center gap-2 px-4 py-2" :class="activeTab === 'stats' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 border border-gray-300'" @click="activeTab = 'stats'">
<i class="fas fa-chart-line text-lg"></i>
推送统计
</button>
<button class="!rounded-button flex items-center gap-2 px-4 py-2" :class="activeTab === 'history' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 border border-gray-300'" @click="activeTab = 'history'">
<i class="fas fa-history text-lg"></i>
推送历史
</button>
</div>
</div>
<!-- 统计图表 -->
<div v-if="activeTab === 'stats'" class="mb-8 bg-white rounded-lg shadow-sm p-6">
<h2 class="text-xl font-semibold text-gray-900 mb-6">推送效果统计</h2>
<!-- <div ref="chartRef" class="w-full h-[400px]"></div> -->
<table class="w-full" v-loading="loading3">
<thead>
<tr class="text-left border-b border-gray-200">
  <th class="py-3 px-4">笔记标题</th>
<th class="py-3 px-4">推送时间</th>
<th class="py-3 px-4">目标城市</th>
<th class="py-3 px-4">推流用户数</th>
<th class="py-3 px-4">曝光量</th>
<th class="py-3 px-4">点击量</th>
<th class="py-3 px-4">点击率</th>
</tr>
</thead>
<tbody>
<tr v-for="item in pushTaskList" :key="item.pushstream_task_id" class="border-b border-gray-100">
<td class="py-3 px-4">{{ item.name }}</td>
<td class="py-3 px-4">{{ item.create_time }}</td>
<td class="py-3 px-4">{{ item.cname}}</td>
<td class="py-3 px-4">{{ item.num}}</td>
<td class="py-3 px-4">{{ item.pushNum }}</td>
<td class="py-3 px-4">{{ item.view }}</td>
<td class="py-3 px-4">{{ item.clickPercent }}</td>
</tr>
</tbody>
</table>
<!--分页-->
<div class="pagination">
    <el-pagination
      @size-change="handleSizeChange3"
      @current-change="handleCurrentChange3"
      background
      :current-page="curPage3"
      :page-size="pageSize3"
      layout="total, prev, pager, next, jumper"
      :total="totalDataNumber3"
    ></el-pagination>
  </div>
</div>
<!-- 推送历史 -->
<div v-if="activeTab === 'history'" class="mb-8 bg-white rounded-lg shadow-sm p-6">
<h2 class="text-xl font-semibold text-gray-900 mb-6">推送历史记录</h2>
<table class="w-full" v-loading="loading2">
<thead>
<tr class="text-left border-b border-gray-200">
<th class="py-3 px-4">笔记标题</th>
<th class="py-3 px-4">推送用户</th>
<th class="py-3 px-4">点击量</th>
<th class="py-3 px-4">推送时间</th>

</tr>
</thead>
<tbody>
<tr v-for="item in pushHistory" :key="item.note_push_stream_id" class="border-b border-gray-100">
<td class="py-3 px-4">{{ item.name }}</td>
<td class="py-3 px-4">{{ item.nickName }}</td>
<td class="py-3 px-4">{{ item.view }}</td>
<td class="py-3 px-4">{{ item.create_time }}</td>
<td class="py-3 px-4"></td>
</tr>
</tbody>
</table>
<!--分页-->
<div class="pagination">
    <el-pagination
      @size-change="handleSizeChange2"
      @current-change="handleCurrentChange2"
      background
      :current-page="curPage2"
      :page-size="pageSize2"
      layout="total, prev, pager, next, jumper"
      :total="totalDataNumber2"
    ></el-pagination>
  </div>
</div>
<div class="grid grid-cols-12 gap-6">
<!-- 左侧笔记选择区 -->
<div class="col-span-7 space-y-6">
<div class="bg-white rounded-lg shadow-sm p-6">
<div class="flex justify-between items-center mb-4">
<h2 class="text-xl font-semibold text-gray-900">选择推送笔记</h2>
<div class="relative w-64">
<input type="text" v-model="articleSearchKey" placeholder="搜索笔记标题" class="w-full pl-10 pr-4 py-2 rounded-lg bg-gray-50 border-none text-sm" @change="changeSearch()"/>
<i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
</div>
</div>
<div class="space-y-3 max-h-[400px] overflow-y-auto" v-loading="loading">
<div v-for="article in articles" :key="article.notes_id" @click="selectArticle(article)" :class="{'border-blue-500 bg-blue-50': selectedArticle.includes(article.notes_id)}" class="p-4 border rounded-lg cursor-pointer hover:border-blue-500 transition-colors">
<div class="flex justify-between items-start">
<h3 class="text-gray-900 font-medium">{{ article.name }}</h3>
<span class="text-xs text-gray-500 whitespace-nowrap ml-4">{{ article.create_time }}</span>
</div>
<p class="mt-2 text-sm text-gray-600 line-clamp-2" v-html="article.context?article.context.replace(/\n/g, '<br>'):''"></p>
</div>
</div>
 <!--分页-->
 <div class="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="curPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="totalDataNumber"
    ></el-pagination>
  </div>
</div>
<!-- 城市选择区 -->
<div class="bg-white rounded-lg shadow-sm p-6">
<div class="flex justify-between items-center mb-4">
<h2 class="text-xl font-semibold text-gray-900">选择目标城市</h2>
<div class="relative w-64">
<input type="text" v-model="citySearchKey" placeholder="搜索城市" class="w-full pl-10 pr-4 py-2 rounded-lg bg-gray-50 border-none text-sm" @change="getCity"/>
<i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
</div>
</div>
<div class="grid grid-cols-4 gap-3 max-h-[300px] overflow-y-auto">
<button v-for="city in cities" :key="city.id" :class="selectedCities.includes(city) ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 border border-gray-300'" @click="toggleCity(city)" class="px-4 py-2 !rounded-button">
{{ city.name }}
</button>
</div>
<!--分页-->
  <div class="pagination">
    <el-pagination
      @size-change="handleSizeChange1"
      @current-change="handleCurrentChange1"
      background
      :current-page="curPage1"
      :page-size="pageSize1"
      layout="total, prev, pager, next, jumper"
      :total="totalDataNumber1"
    ></el-pagination>
  </div>
</div>
</div>
<!-- 右侧推送控制面板 -->
<div class="col-span-5">
<div class="bg-white rounded-lg shadow-sm p-6 sticky top-6">
<h2 class="text-xl font-semibold text-gray-900 mb-6">推送配置</h2>
<div class="space-y-6">
<!-- 推送摘要 -->
<div class="bg-gray-50 rounded-lg p-4">
<div class="flex items-center justify-between mb-3">
<span class="text-gray-600">已选笔记</span>
<span class="text-blue-500">{{ selectedArticle.length }} 篇</span>
</div>
<div class="flex items-center justify-between">
<span class="text-gray-600">目标城市</span>
<span class="text-blue-500">{{ selectedCities.length }} 个</span>
</div>
</div>
<!-- 推送时间设置 -->
<div>
<p class="text-sm font-medium text-gray-700 mb-2">推送时间</p>
<div class="flex gap-4 w-full">
<button @click="pushType = 'immediate'" :class="pushType === 'immediate' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 border border-gray-300'" class="flex-1 px-4 py-2 !rounded-button">立即推送</button>
<button @click="pushType = 'scheduled'" :class="pushType === 'scheduled' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 border border-gray-300'" class="flex-1 px-4 py-2 !rounded-button">定时推送</button>
</div>
</div>
<!-- 定时选择器 -->
<div v-if="pushType === 'scheduled'" class="space-y-2">
<p class="text-sm font-medium text-gray-700">选择推送时间</p>
<input type="datetime-local" v-model="scheduledTime" class="w-full px-4 py-2 rounded-lg bg-gray-50 border-none" />
</div>
<!-- 推送数量 -->
<div>
<p class="text-sm font-medium text-gray-700 mb-2">推送数量</p>
<textarea v-model="pushNum" rows="3" placeholder="输入推送数量" class="w-full px-4 py-2 rounded-lg bg-gray-50 border-none resize-none"></textarea>
</div>
<!-- 推送说明 -->
<div>
<p class="text-sm font-medium text-gray-700 mb-2">推送说明（选填）</p>
<textarea v-model="pushNote" rows="3" placeholder="输入推送说明或备注信息..." class="w-full px-4 py-2 rounded-lg bg-gray-50 border-none resize-none"></textarea>
</div>
<!-- 操作按钮 -->
<div class="flex gap-4">
<!-- <button @click="previewPush" class="flex-1 px-4 py-2 bg-white text-gray-700 border border-gray-300 !rounded-button">预览推送</button> -->
<button @click="confirmPush" :disabled="!canPush" :class="!canPush ? 'opacity-50 cursor-not-allowed' : ''" class="flex-1 px-4 py-2 bg-blue-500 text-white !rounded-button">确认推送</button>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script >
import * as echarts from 'echarts';
import NotesApi from '@/api/notes.js';
import { stringify } from 'postcss';
export default {
  data() {
    return {
      activeTab: 'stats',
      chartRef: null,
      articleSearchKey: '',
      citySearchKey: '',
      selectedArticle: [],
      selectedCities: [],
      pushType: 'immediate',
      scheduledTime: '',
      pushNote: '',
      pushNum:10000,
      /*是否加载完成*/
      loading: true,
      loading2:false,
      loading3:false,
      /*列表数据*/
      articles: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      // 其他城市数据...
      cities: [],
      /*一页多少条*/
      pageSize1: 20,
      /*一共多少条数据*/
      totalDataNumber1: 0,
      /*当前是第几页*/
      curPage1: 1,
      pushHistory: [],
       /*一页多少条*/
       pageSize2: 20,
      /*一共多少条数据*/
      totalDataNumber2: 0,
      /*当前是第几页*/
      curPage2: 1,
      pushTaskList: [],
      /*一页多少条*/
      pageSize3: 20,
      /*一共多少条数据*/
      totalDataNumber3: 0,
      /*当前是第几页*/
      curPage3: 1,
    };
  },
  computed: {
    canPush() {
      return this.selectedArticle && 
             this.selectedCities.length > 0 &&
             (this.pushType === 'immediate' || 
              (this.pushType === 'scheduled' && this.scheduledTime));
    }
  },
  watch:{
    activeTab(newValue){
      if(newValue == "history"){
        this.getpushHistory();
      }else{
        this.getPushTaskList();
      }
    }
  },
  mounted() {
    this.getPushTaskList();
    this.initChart();
    this.getCity();
    this.getList();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
     /*选择第几页*/
     handleCurrentChange1(val) {
      this.curPage1 = val;
      this.getCity();
    },

    /*每页多少条*/
    handleSizeChange1(val) {
      this.curPage1 = 1;
      this.pageSize1 = val;
      this.getCity();
    },
    getCity(){
      let self = this;
      let Params = {"level":2,"name":this.citySearchKey};
      Params.page = self.curPage1;
      Params.list_rows = self.pageSize1;
       NotesApi.getCity(Params, true)
        .then(data => { 
          self.cities = data.data.list.data;
          self.totalDataNumber1 = data.data.list.total;
          console.log(self.cities,self.totalDataNumber1);
        })
        .catch(error => {
        });
    },
    changeSearch(){
      this.curPage = 1;
      this.getList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getList();
    },
     /*选择第几页*/
     handleCurrentChange2(val) {
      this.curPage2 = val;
      this.getpushHistory();
    },

    /*每页多少条*/
    handleSizeChange2(val) {
      this.curPage2 = 1;
      this.pageSize2 = val;
      this.getpushHistory();
    },
     /*选择第几页*/
     handleCurrentChange3(val) {
      this.curPage3 = val;
      this.getPushTaskList();
    },

    /*每页多少条*/
    handleSizeChange3(val) {
      this.curPage3 = 1;
      this.pageSize3 = val;
      this.getPushTaskList();
    },
    getList(){
        var Params = {'search':this.articleSearchKey}
        let self = this;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        NotesApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.articles = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },
    initChart() {
      if (!this.$refs.chartRef) return;
      const myChart = echarts.init(this.$refs.chartRef);
      const option = {
        // 保持原有图表配置不变
        animation: false,
        tooltip: { trigger: 'axis' },
        xAxis: { /* ... */ },
        yAxis: { /* ... */ },
        series: [ /* ... */ ]
      };
      myChart.setOption(option);
      this.chartInstance = myChart;
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    selectArticle(article) {
      const index = this.selectedArticle.indexOf(article.notes_id);
      if (index === -1) {
        this.selectedArticle.push(article.notes_id);
      } else {
        this.selectedArticle.splice(index, 1);
      }
    },
    toggleCity(city) {
      const index = this.selectedCities.indexOf(city);
      if (index === -1) {
        this.selectedCities.push(city);
      } else {
        this.selectedCities.splice(index, 1);
      }
    },
    previewPush() {
      console.log('Preview push');
    },
    getpushHistory(){
      let self = this;
      let Params = {};
        Params.page = self.curPage2;
        Params.list_rows = self.pageSize2;
        self.loading2 = true;
        NotesApi.getPushTaskList(Params, true)
          .then(data => {
            self.loading2 = false;
            self.pushHistory = data.data.list.data;
            self.totalDataNumber2 = data.data.list.total;
          })
          .catch(error => {
          });
    },
    getPushTaskList(){
      let self = this;
      let Params = {};
        Params.page = self.curPage3;
        Params.list_rows = self.pageSize3;
        self.loading3 = true;
        NotesApi.getPushList(Params, true)
          .then(data => {
            self.loading3 = false;
            self.pushTaskList = data.data.list.data;
            self.pushTaskList.map((item)=>{
              item.cname = JSON.parse(item.cities).map(user => user.name).join(',');
              item.clickPercent = item.pushNum>0?(Number(((item.view / item.pushNum)*100000/100000).toFixed(2))*100 + "%"):0;//点击率
            });
            self.totalDataNumber3 = data.data.list.total;
          })
          .catch(error => {
          });
    },
    addPushNote(notes_id){
      let self = this;
      console.log('self.selectedCities',self.selectedCities);
      let city = self.selectedCities;
      console.log(city);
       let Params = {
        "notes_id":notes_id,
        "cities":JSON.stringify(city),
        "num":self.pushNum,
        "start_time":self.pushType=="immediate"? Math.floor(Date.now() / 1000):self.scheduledTime,
        "status":self.pushType=="immediate"? 1:0,
        "desc":self.pushNote,
       }
        NotesApi.addPushNote(Params, true)
          .then(data => {
            self.$message({
                type: 'success',
                message: '操作成功'
            });
            console.log(data);
          })
          .catch(error => {
            self.$message({
                type: 'success',
                message: '操作失败'
            });
          });
    },
    confirmPush() {
      if (!this.canPush) return;
      let self = this;
      if(self.selectedArticle.length>0){
        self.selectedArticle.map((item)=>{
          self.addPushNote(item);
        });
      }
      console.log('Confirm push');
      // 这里添加实际的推送逻辑
    }
  }
};
</script>
<style scoped>
.overflow-y-auto {
max-height: 400px;
scrollbar-width: thin;
scrollbar-color: #E5E7EB transparent;
}
.overflow-y-auto::-webkit-scrollbar {
width: 6px;
}
.overflow-y-auto::-webkit-scrollbar-track {
background: transparent;
}
.overflow-y-auto::-webkit-scrollbar-thumb {
background-color: #E5E7EB;
border-radius: 3px;
}
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
filter: invert(0.5);
}
textarea::placeholder,
input::placeholder {
color: #9CA3AF;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/pushstream/index/index.vue